class TSAuthorization extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;
    this.customerLogedIn = this.dataset.customer === "true";
    this.COUNTRY_CODE = this.dataset.country;
  }

  connectedCallback() {
    this.initClickEvents();
    this.initInputEvents();
    this.initSubmitEvents();
  }

  validateFields(form) {
    if (!form) return false;

    let validationResult = false;

    if (form.id === "RecoveryForm") {
      validationResult = this.validateRecoveryFields(form);
    } else if (form.id === "RegisterForm") {
      validationResult = this.validateRegisterFields(form);
    } else if (
      form.getAttribute("id") === "ActivateForm" ||
      form.getAttribute("id") === "ResetForm"
    ) {
      validationResult = this.validatePasswordFields(form);
    }

    return validationResult;
  }

  validateRecoveryFields(form) {
    if (!form) return false;
    let hasNoErrors = true;

    form.querySelectorAll("[data-field]").forEach((field) => {
      const input = field.querySelector("input");
      const errorField = field.querySelector("[data-field-error]");

      if (input.name == "email") {
        if (!input.value.trim()) {
          errorField.innerText = window.authorizationStrings.email_empty;
          hasNoErrors = false;
        } else if (!input.checkValidity()) {
          errorField.innerText = window.authorizationStrings.email;
          hasNoErrors = false;
        } else {
          errorField.innerText = "";
        }
      }
    });

    return hasNoErrors;
  }

  validateRegisterFields(form) {
    let hasNoErrors = true;

    form.querySelectorAll("[data-field]").forEach((field) => {
      const input = field.querySelector("input");
      const errorField = field.querySelector("[data-field-error]");

      if (input.name == "first-name") {
        if (!input.value.trim()) {
          errorField.innerText = window.authorizationStrings.name_empty;
          hasNoErrors = false;
        } else if (input.value.length > 50) {
          errorField.innerText = window.authorizationStrings.name_limit;
          hasNoErrors = false;
        } else {
          errorField.innerText = "";
        }
      } else if (input.name == "last-name") {
        if (!input.value.trim()) {
          errorField.innerText = window.authorizationStrings.surname_empty;
          hasNoErrors = false;
        } else if (input.value.length > 50) {
          errorField.innerText = window.authorizationStrings.surname_limit;
          hasNoErrors = false;
        } else {
          errorField.innerText = "";
        }
      } else if (input.name == "email") {
        if (!input.value.trim()) {
          errorField.innerText = window.authorizationStrings.email_empty;
          hasNoErrors = false;
        } else if (!input.checkValidity()) {
          errorField.innerText = window.authorizationStrings.email;
          hasNoErrors = false;
        } else {
          errorField.innerText = "";
        }
      } else if (input.name == "password") {
        if (!input.value.trim()) {
          errorField.innerText =
            window.authorizationStrings.password_register_empty;
          hasNoErrors = false;
        } else if (input.value.trim().length < 6) {
          errorField.innerText = window.authorizationStrings.password_register;
          hasNoErrors = false;
        } else {
          errorField.innerText = "";
        }
      } else if (input.name == "password-confirm") {
        if (!input.value.trim()) {
          errorField.innerText =
            window.authorizationStrings.password_validation_empty;
          hasNoErrors = false;
        } else if (
          input.value.trim() !==
          form.querySelector("[name='password']").value.trim()
        ) {
          errorField.innerText =
            window.authorizationStrings.password_validation;
          hasNoErrors = false;
        } else {
          errorField.innerText = "";
        }
      } else if (input.name === "phone") {
        if (this.querySelector("#RegisterConsentSms").checked) {
          if (!input.value.trim()) {
            errorField.innerText = window.authorizationStrings.phone_empty;
            hasNoErrors = false;
          } else if (!this.isValidPhoneNumber(input.value)) {
            if (this.COUNTRY_CODE == "JP") {
              errorField.innerText = window.authorizationStrings.jp_phone;
            } else {
              errorField.innerText = window.authorizationStrings.us_phone;
            }
            hasNoErrors = false;
          } else {
            errorField.innerText = "";
          }
        } else if (input.value.trim()) {
          if (!this.isValidPhoneNumber(input.value)) {
            if (this.COUNTRY_CODE == "JP") {
              errorField.innerText = window.authorizationStrings.jp_phone;
            } else {
              errorField.innerText = window.authorizationStrings.us_phone;
            }
            hasNoErrors = false;
          } else {
            errorField.innerText = "";
          }
        } else {
          errorField.innerText = "";
        }
      } else if (input.name == "agreement") {
        console.log(input.checked);
        if (!input.checked) {
          errorField.innerText = window.authorizationStrings.agreement;
          hasNoErrors = false;
        } else {
          errorField.innerText = "";
        }
      }
    });
    console.log("hasNoErrors", hasNoErrors);
    return hasNoErrors;
  }

  validatePasswordFields(form) {
    let hasNoErrors = true;

    form.querySelectorAll("[data-field]").forEach((field) => {
      const input = field.querySelector("input");
      const errorField = field.querySelector("[data-field-error]");

      if (input.name == "customer[password]") {
        if (!input.value.trim()) {
          errorField.innerText =
            window.authorizationStrings.password_register_empty;
          hasNoErrors = false;
        } else if (input.value.trim().length < 6) {
          errorField.innerText = window.authorizationStrings.password_register;
          hasNoErrors = false;
        } else {
          errorField.innerText = "";
        }
      } else if (input.name == "customer[password_confirmation]") {
        if (!input.value.trim()) {
          errorField.innerText =
            window.authorizationStrings.password_validation_empty;
          hasNoErrors = false;
        } else if (
          input.value.trim() !==
          form.querySelector("[name='customer[password]']").value.trim()
        ) {
          errorField.innerText =
            window.authorizationStrings.password_validation;
          hasNoErrors = false;
        } else {
          errorField.innerText = "";
        }
      }
    });

    return hasNoErrors;
  }

  createCustomer() {
    const form = this.querySelector("#RegisterForm");

    const formData = new FormData(form);
    const dataJson = Object.fromEntries(formData.entries());
    const messageElement = form.querySelector("[data-message]");
    messageElement.innerText = "";
    if (!this.isLoading) {
      this.isLoading = !this.isLoading;
      this.classList.toggle("loading", this.isLoading);
    }

    let birthdate = "";

    const year = form.querySelector('[name="year"]').value || false;
    const month = form.querySelector('[name="month"]').value || false;
    const day = form.querySelector('[name="day"]').value || false;

    if (year && month && day) {
      birthdate = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }

    const data = {
      first_name: form.querySelector('[name="first-name"]').value,
      last_name: form.querySelector('[name="last-name"]').value,
      email: form.querySelector('[name="email"]').value,
      phone: this.formatPhoneNumber(form.querySelector('[name="phone"]').value),
      gender: form.querySelector('[name="gender"]').value,
      birthdate: birthdate,
      email_consent: form.querySelector('[name="consent-email"]').checked,
      sms_consent: form.querySelector('[name="consent-sms"]').checked,
      locale: form.querySelector('[name="locale"]').value,
      hCaptcha: dataJson["h-captcha-response"] || null,
    };

    if (dataJson["first_name"] || dataJson["last_name"]) {
      this.isLoading = !this.isLoading;
      this.classList.toggle("loading", this.isLoading);

      messageElement.innerText = errorFormMessages?.request?.bad || "";
      return;
    }

    fetch(window.apiURL + "/customer/create", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((response) => {
        console.log("response", response);
        if (response.statusCode !== 200) {
          if (response.message.includes("Email is already in use"))
            messageElement.innerText = errorMessages.email_exist;
          else if (response.message.includes("Phone has already been taken"))
            messageElement.innerText = errorMessages.phone_exist;
          else if (response.message.includes("email_exist"))
            messageElement.innerText = errorMessages.email_exist;
          else if (response.message.includes("phone_exist"))
            messageElement.innerText = errorMessages.phone_exist;
          else if (response?.message[0]?.includes("must be an"))
            messageElement.innerText = errorFormMessages.field.invalid;
          else if (response.message.includes("invalid_captcha"))
            messageElement.innerText = errorFormMessages.form?.invalid_captcha;
          else messageElement.innerText = response.message;

          //hcaptcha.reset();
          let error = new Error(response.message);
          throw error;
        } else {
          messageElement.innerText = "";

          // if checkout_url
          const params = new URLSearchParams(window.location.search);
          const returnUrl =
            params.get("return_to") || params.get("checkout_url");

          const activationUrl = response.activationUrl;
          const [base, rest] = activationUrl.split("/account");
          const newUrl = `${
            Shopify?.routes?.root ? Shopify?.routes?.root : "/"
          }account${rest}`;

          window.location.href =
            newUrl + (returnUrl ? `?return_to=${returnUrl}` : "");
        }
      })
      .catch((error) => {
        //messageElement.innerText = errorFormMessages?.request?.bad || "";
        console.error(error);
      })
      .finally(() => {
        this.isLoading = !this.isLoading;
        this.classList.toggle("loading", this.isLoading);
      });
  }

  isValidPhoneNumber(input) {
    return !!this.formatPhoneNumber(input);
  }

  formatPhoneNumber(input) {
    if (!input) return null;

    const digits = input.trim().replace(/\D/g, "");

    if (this.COUNTRY_CODE === "US") {
      let number = digits;

      if (number.length === 10) {
        number = "1" + number;
      }

      if (number.length === 11 && number.startsWith("1")) {
        return "+" + number;
      }

      return null;
    }

    if (this.COUNTRY_CODE === "JP") {
      let number = digits;

      if (
        number.startsWith("81") &&
        (number.length === 11 || number.length === 12)
      ) {
        return "+" + number;
      }

      if (
        number.startsWith("0") &&
        (number.length === 10 || number.length === 11)
      ) {
        number = "81" + number.slice(1);
        return "+" + number;
      }

      return null;
    }

    return null;
  }

  generateDateDayOptions(selector) {
    selector.innerHTML = "";
    for (let i = 1; i <= daysInMonth; i++) {
      const dayDiv = document.createElement("div");
      dayDiv.className = "ts-authorization__option";
      dayDiv.dataset.trigger = "select-option";
      dayDiv.innerText = i;
      dayOptionContainer.appendChild(dayDiv);
    }
  }

  initClickEvents() {
    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-trigger")) {
        switch (e.target.dataset.trigger) {
          case "open-recovery":
            if (this.querySelector("#RecoveryForm")) {
              this.querySelector("[data-popup]").classList.add("open");
            }
            break;
          case "close-recovery":
            this.querySelector("[data-popup]").classList.remove("open");
            break;
          case "toggle-select":
            e.target.classList.toggle("open");
            break;
          case "select-option":
            const select = e.target.closest("[data-field-select]");
            select.classList.remove("open");

            if (e.target.hasAttribute("data-value")) {
              select.querySelector("input").value = e.target.dataset.value;
            } else select.querySelector("input").value = e.target.innerText;

            select.querySelector(".active")?.classList.remove("active");
            e.target.classList.add("active");

            this.validateFields(this.querySelector("form"));
            break;

          case "select-option-year":
            const selectYear = e.target.closest("[data-field-select]");
            selectYear.classList.remove("open");

            if (e.target.hasAttribute("data-value")) {
              selectYear.querySelector("input").value = e.target.dataset.value;
            } else selectYear.querySelector("input").value = e.target.innerText;

            selectYear.querySelector(".active")?.classList.remove("active");
            e.target.classList.add("active");

            const dateYearRow = e.target.closest(
              ".ts-authorization__field-row"
            );

            dateYearRow.querySelector("[name='month']").value = null;

            dateYearRow.querySelector("[name='day']").value = null;

            this.validateFields(this.querySelector("form"));
            break;

          case "select-option-month":
            const selectMonth = e.target.closest("[data-field-select]");
            selectMonth.classList.remove("open");

            selectMonth.querySelector("input").value = e.target.innerText;

            selectMonth.querySelector(".active")?.classList.remove("active");
            e.target.classList.add("active");

            // get year from year field
            const dateRow = e.target.closest(".ts-authorization__field-row");
            const getYear = dateRow.querySelector("[name='year']").value;

            const daysInMonth = new Date(
              getYear,
              e.target.innerHTML,
              0
            ).getDate();
            const birthday = dateRow.querySelector("[name='day']");

            if (birthday.value > daysInMonth) {
              birthday.value = daysInMonth;
            }

            const dayOptionContainer = dateRow.querySelector(
              "[data-field-day] .ts-authorization__select"
            );
            dayOptionContainer.innerHTML = "";
            for (let i = 1; i <= daysInMonth; i++) {
              const dayDiv = document.createElement("div");
              dayDiv.className = "ts-authorization__option";
              dayDiv.dataset.trigger = "select-option";
              dayDiv.innerText = i;
              dayOptionContainer.appendChild(dayDiv);
            }

            this.validateFields(this.querySelector("form"));
            break;

          case "select-option-gender":
            const selectGender = e.target.closest("[data-field-select]");
            selectGender.classList.remove("open");
            selectGender.querySelector("input[name='gender']").value =
              e.target.dataset.value;
            selectGender.querySelector("#RegisterGender").value =
              e.target.innerText;

            selectGender.querySelector(".active")?.classList.remove("active");
            e.target.classList.add("active");
            this.validateFields(this.querySelector("form"));
            break;
        }
      } else if (e.target.hasAttribute("data-field-show")) {
        const field = e.target.closest("[data-field]");
        field.classList.toggle("show-pass");
        field.querySelector("input").type = field.classList.contains(
          "show-pass"
        )
          ? "text"
          : "password";
      }
    });

    document.addEventListener("click", (e) => {
      this.querySelectorAll("[data-field-select]").forEach((select) => {
        if (select !== e.target.closest("[data-field-select]")) {
          select.classList.remove("open");
        }
      });
    });
  }

  initInputEvents() {
    this.addEventListener("input", (e) => {
      this.validateFields(e.target.closest("form"));
    });
  }

  initSubmitEvents() {
    const formList = this.querySelectorAll("form");

    formList.forEach((form) => {
      form.addEventListener("submit", (e) => {
        e.preventDefault();

        if (this.validateFields(form)) {
          if (form.id === "RegisterForm") return this.createCustomer();

          if (form.getAttribute("id") === "ActivateForm") {
            const params = new URLSearchParams(window.location.search);
            const returnUrl =
              params.get("checkout_url") || params.get("return_to");

            if (returnUrl) {
              form.querySelector("[name='return_to']").value = returnUrl;
            }
            return form.submit();
          }
          //console.log("Form submit", form);
          form.submit();
        }
      });
    });
  }
}

customElements.define("ts-authorization", TSAuthorization);
